export default class DtoLocation {
    constructor(obj, altitude = '') {
        this.x = obj.x
        this.y = obj.y
        this.z = obj.z || altitude
        this.projection = obj.projection
    }
}